import { render, staticRenderFns } from "./Solid.vue?vue&type=template&id=4104ebc6&scoped=true"
import script from "./Solid.vue?vue&type=script&lang=js"
export * from "./Solid.vue?vue&type=script&lang=js"
import style0 from "./Solid.vue?vue&type=style&index=0&id=4104ebc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104ebc6",
  null
  
)

export default component.exports